// src/helpers/reducer.ts
var reducer = (accumulator, pair) => {
  const currentValue = accumulator[pair.name];
  if (currentValue === void 0) {
    accumulator[pair.name] = pair.value;
    return accumulator;
  }
  if (Array.isArray(currentValue)) {
    currentValue.push(pair.value);
    return accumulator;
  }
  accumulator[pair.name] = [currentValue, pair.value];
  return accumulator;
};

export { reducer };
//# sourceMappingURL=chunk-KT7MO6Z4.js.map
//# sourceMappingURL=chunk-KT7MO6Z4.js.map